import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box} from 'views/components';
import {AccessTime as AccessTimeIcon} from 'views/icons';
import {getEventStatusStyles} from 'views/module';

import moment from 'moment';

const MonthlyEventTile = (props) => {
  const {event} = props.event;

  const startTime = moment(event.eventData.startTime).format('hh:mmA');

  const styles = getEventStatusStyles({event});

  return (
    <Box
      sx={{
        'background': styles.background,
        'borderRadius': 1,
        'p': 1,
        'pb': 0.5,
        'mb': 0,
        'borderLeft': `3px solid ${styles.borderColor}`,
        'cursor': 'pointer',
        'width': '100%',
        'height': '100%',
        'flexDirection': 'row',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          fontWeight: 'medium',
          color: styles.textColor,
          fontSize: '11px',
          flex: 1,
          mr: 1,
          textDecoration: styles.isInactive ? 'line-through' : 'none',
        }}
      >
        {event.info.title}
      </Typography>
      {
        styles.isInactive &&
        <Typography
          variant="caption"
          sx={{
            border: `1px solid ${styles.borderColor}`,
            borderRadius: 1,
            color: styles.textColor,
            fontWeight: 'medium',
            fontSize: '10px',
            lineHeight: 1,
            px: 0.5,
            mr: 0.5,
            flexShrink: 0,
          }}
        >
          {styles.label}
        </Typography>
      }
      <Typography
        variant="caption"
        sx={{
          opacity: 0.7,
          color: '#616161',
          display: 'flex',
          alignItems: 'center',
          fontSize: '10px',
          flexShrink: 0,
        }}
      >
        <AccessTimeIcon sx={{fontSize: '0.8rem', mr: 0.3}} />
        {startTime}
      </Typography>
    </Box>
  );
};

MonthlyEventTile.propTypes = {
  event: PropTypes.object.isRequired,
};

export default MonthlyEventTile;
